module.exports = __webpack_public_path__ + "static/media/big-arrow-right.ee2a5ffb.svg";